export { BirdieBoard, type BirdieBoardStats } from './BirdieBoard'
export { BIRDIE_ARC_SLOT_CLASS, boardFor, type BoardKind } from './boardFor'
export { BirdieBallDefs } from './GolfBall'
